import styled from 'styled-components'

import { AnchorLink } from 'gatsby-plugin-anchor-links'

export const LinkAnchor = styled(AnchorLink)`
  text-decoration: none;
`
